export default __webpack_public_path__ + "static/media/IMG_2356.8f1db063.jpg";